import React from "react";



const ErrorMessageConstant = ({
  message,

}) => {


  return (
    <div className="errormessage" >
      <span>{message}</span>
    </div>
  );
};



export default ErrorMessageConstant;



// WEBPACK FOOTER //
// ./src/components/common/ErrorMessageConstant.js